import { useState, useContext, useRef } from "react";

// styles
import styles from "./Form.module.scss";

// functions
import {
  AppdataContext,
  AppdataDispatchContext,
} from "../../functions/appdataContext";
import { initiateSwishPayment } from "../../functions/swishCalls";
import { formatNumberString } from "../../functions/formatValue";
import { inputValidation } from "../../functions/inputValidation";
import { getErrorMessage } from "../../functions/getErrorMessage";

// components
import Button from "../Button/Button";
import InputField from "../InputField/InputField";
import Typography from "../Typography/Typography";
import RadioGroup from "../RadioGroup/RadioGroup";
import Radio from "../Radio/Radio";

const Form = ({ setIsPollModalActive }) => {
  const appdata = useContext(AppdataContext);
  const dispatch = useContext(AppdataDispatchContext);

  const stateRef = useRef();
  stateRef.current = appdata;

  const [customAmount, setCustomAmount] = useState("");

  const handleCustomAmount = (e) => {
    e.preventDefault();
    setCustomAmount(e.target.value);
    onChangeInput(e);
  };

  const { initialServerData, formData, formErrors, formSuccess } = appdata;
  const { amounts } = initialServerData || {};

  const canSubmit =
    formData &&
    Object.values(formData).every((x) => x !== "" && x !== false) &&
    Object.values(formErrors).every((x) => x === "");

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      dispatch({
        type: "setFormValue",
        value: { name, value: formatNumberString(value) },
      });
    } else {
      dispatch({
        type: "setFormValue",
        value: { name, value },
      });
    }
  };

  const onChangeInputRadioOrCheckbox = (name, value) => {
    if (formErrors?.customAmount && formErrors.customAmount !== "") {
      clearFormError("customAmount");
      setCustomAmount("");
    }

    dispatch({
      type: "setFormValue",
      value: { name, value },
    });
  };

  const clearFormError = (name) => {
    dispatch({
      type: "setFormErrorValue",
      value: { name, value: "" },
    });
  };

  const clearFormSuccess = (name) => {
    if (formSuccess[name]) {
      dispatch({
        type: "setFormSuccessValue",
        value: { name, value: false },
      });
    }
  };

  const clearFormResponse = (name) => {
    clearFormError(name);
    clearFormSuccess(name);
  };

  const handleInputValidation = (name, value) => {
    const isValid = inputValidation({ name, value });

    if (isValid || !value) {
      clearFormError(name);

      if (value) {
        dispatch({
          type: "setFormSuccessValue",
          value: { name, value: true },
        });
      }
    } else {
      dispatch({
        type: "setFormErrorValue",
        value: { name, value: getErrorMessage(name) },
      });
    }
  };

  const handleInputFocus = (e) => {
    const { name } = e.target;
    clearFormResponse(name);
  };

  const radioVariant = "button-selector";

  // WP: Submit form
  const handleSubmit = (event) => {
    event.preventDefault();

    setIsPollModalActive(true);
    initiateSwishPayment(event.target, stateRef, dispatch);

    console.log("submit swish modal form");
  };

  return (
    <form onSubmit={handleSubmit} className={styles["form"]}>
      <div className={styles["input-fields"]}>
        <RadioGroup
          onValueChange={(value) =>
            onChangeInputRadioOrCheckbox("amount", value)
          }
          value={formData?.amount}
          variant={radioVariant}
        >
          {amounts?.map((item, index) => {
            const radioProps = {
              key: `amount-${index}-${item.amount}`,
              id: `amount-${index}-${item.amount}`,
              value: item.amount,
              label: `${item.amount} kr`,
              variant: radioVariant,
            };

            return <Radio {...radioProps} />;
          })}

          <Radio
            id={`amount-3-custom`}
            value={customAmount}
            label={
              initialServerData?.radio_customAmount
                ? initialServerData?.radio_customAmount
                : "Annat belopp"
            }
            variant={radioVariant}
          />
        </RadioGroup>

        {customAmount === formData?.amount && (
          <InputField
            type="number"
            name="amount"
            id="custom-amount"
            onChange={handleCustomAmount}
            value={formData?.amount}
            label={
              initialServerData?.input_customAmount?.label
                ? initialServerData?.input_customAmount?.label
                : "Belopp i kronor"
            }
            hint={initialServerData?.input_customAmount?.hint}
            min="50"
            onWheel={(e) => e.target.blur()}
            onFocus={() => clearFormResponse("customAmount")}
            onBlur={(event) =>
              handleInputValidation("customAmount", event.target.value)
            }
            error={formErrors?.customAmount}
            su
            required
          />
        )}

        <InputField
          type="tel"
          name="phone"
          id="phone"
          onChange={onChangeInput}
          onFocus={(event) => handleInputFocus(event)}
          onBlur={(event) => handleInputValidation("phone", event.target.value)}
          value={formData.phone}
          label="Telefonnummer*"
          error={formErrors?.phone}
        />
      </div>

      <Button type="submit" disabled={!canSubmit} id="swish-module-submit">
        Swisha en gåva
      </Button>

      <Typography>
        När du fyller i dina uppgifter sparar vi ditt telefonnummer för att
        kunna kontakta dig.
      </Typography>
    </form>
  );
};
export default Form;
